import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { ContentWrapper } from "../components/Nav";
import helpPages from "../data/help";
import "./styles/Help.scss";

export default class Help extends React.Component {
  render() {
    return (
      <ContentWrapper>
        <Container className="helpContainer">
          <h2>Find information about popular help topics below</h2>
          <Row>
            {Object.keys(helpPages).map((key, index) => {
              const page = helpPages[key];

              return (
                <Col key={index} md={4}>
                  <Link to={`/help/${key}`}>
                    <h3>{page.title}</h3>
                  </Link>
                  <p>{page.summary}</p>
                </Col>
              );
            })}
          </Row>
          <h4>
            Still have questions? Email us at{" "}
            <a href="mailto:getsafebox@gmail.com">getsafebox@gmail.com</a>.
          </h4>
        </Container>
      </ContentWrapper>
    );
  }
}
